/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import API from 'src/apis';
import MobileNavigation from 'src/components/organisms/mobile_navigation';
import { setOpenAIPDFResponse, setOpenAIResponse, setPdfData, setTextQuery } from 'src/redux/slices/open_ai';
import helper from 'src/helpers';
import { AppType, fetchTatvaAiToken, getFaviconUrl, setAppType } from 'src/helpers/rest';
import { useAppSelector } from 'src/redux/store';
import BrandLoading from 'src/components/atoms/brand_loading';

import LandingIcon from 'src/assets/images/landing_page.gif';
import pdfIcon from 'src/assets/images/pdf.png';

import { BASE } from 'src/common/constants';
import styles from './index.module.scss';

const HistoryPage: React.FunctionComponent = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { version } = useAppSelector(state => state.socket);

    const [width, setWidth] = useState<number>(window.innerWidth);
    const [loading, setLoading] = useState<boolean>(false);
    const [histories, setHistories] = useState<Array<any>>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [tokenLoading, setTokenLoading] = useState<boolean>(true);
    const [appType, _setAppType] = useState<AppType>('tatva_ai');

    // useEffect(() => {
    //     // Prevent reader mode
    //     const metaTag = document.createElement('meta');
    //     metaTag.name = 'apple-mobile-web-app-capable';
    //     metaTag.content = 'yes';
    //     document.head.appendChild(metaTag);

    //     const readerModePreventionMeta = document.createElement('meta');
    //     readerModePreventionMeta.name = 'apple-mobile-web-app-status-bar-style';
    //     readerModePreventionMeta.content = 'default';
    //     document.head.appendChild(readerModePreventionMeta);

    //     return () => {
    //         document.head.removeChild(metaTag);
    //         document.head.removeChild(readerModePreventionMeta);
    //     };
    // }, []);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const authToken = searchParams.get('authToken');

        if (!authToken) {
            setTokenLoading(false);
            fetchHistory();
        } else {
            localStorage.clear();
            setAppType(searchParams, _setAppType);
            const url = new URL(window.location.href);
            url.searchParams.delete('authToken');
            url.searchParams.delete('app');
            window.history.replaceState(null, '', url.toString());
            fetchTatvaAiToken(authToken, setTokenLoading);
        }
    }, [searchParams]);
    
    const fetchHistory = async () => {
        if (loading) return;
        try {
            setLoading(true);
            const url = new URL(BASE.API_HOST);
            url.searchParams.append('page', String(page));
            url.searchParams.append('limit', '20');

            const jsonData = await API.GetHistory(url.search);
            const structuredData = helper.modifyHistoryResponseData(jsonData);
            if (jsonData.data && jsonData.data.length && structuredData.data.length) {
                setHistories(prevItems => [...prevItems, ...structuredData.data]);
            }

            setPage(prevPage => prevPage + 1);
            setHasMore(structuredData.data.length > 0);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const onPressHistory = (history: any) => {
        if (history?.is_pdf) {
            const { document_id, document_name, document_url } = history?.pdfData ?? {};
            dispatch(setPdfData({ document_id, document_name, document_url }));
            dispatch(setOpenAIPDFResponse([...history.openAiResponses]));
            dispatch(setTextQuery(''));
            navigate('/pdf-chat');
        } else {
            dispatch(setOpenAIResponse([...history.openAiResponses]));
            navigate(version === 'v1' ? '/v1' : '/');
        }
    };

    return (<div>
        {tokenLoading
            ? <BrandLoading app={appType}/>
            : <div className={styles.history_wrapper}>
                <div className={styles.history_content}>
                    {width > 900 && <span className={styles.history_page_heading}>Thread</span>}

                    {width < 900 &&
                        <div className={styles.mobile_history_header}>
                            <span className={styles.mobile_history_heading}>History</span>
                            {/* <input
                            type='search'
                            className={styles.mobile_history_search}
                            placeholder='search'
                        /> */}
                        </div>
                    }

                    <div className={styles.history_content_container}>
                        <InfiniteScroll
                            dataLength={histories.length}
                            next={fetchHistory}
                            hasMore={hasMore}
                            loader={false}
                        >
                            {histories.map((history, index) => {
                                const openAiResponse = history.openAiResponses[0];
                                const articleTitles = openAiResponse?.sources?.ArticleTitle || {};
                                const articleKeys = Object.keys(articleTitles);
                                const displayedKeys = articleKeys.slice(0, 3);
                                const remainingCount = articleKeys.length - displayedKeys.length;

                                return (
                                    <div key={history.id || index} className={styles.history_data} onClick={() => onPressHistory(history)}>
                                        <span className={styles.history_question}>{openAiResponse.query || ''}</span>
                                        <div className={styles.history_answer} dangerouslySetInnerHTML={{ __html: (openAiResponse?.answer || '').replace(/\*\*|\ -\ /g, '') }}></div>
                                        {history?.is_pdf
                                            ? <div style={{ display: 'flex', alignContent: 'center' }}>
                                                <img src={pdfIcon} style={{ height: '25px', width: '25px' }} alt="pdf_icon" />
                                                <samp style={{ alignContent: 'end', marginLeft: '5px' }}>{history?.pdfData?.document_name}</samp>
                                            </div>
                                            : <>
                                                {openAiResponse?.sources && (
                                                    <div className={styles.history_images}>
                                                        {displayedKeys.map((source, idx) => (
                                                            <div key={idx} className={styles.history_image_group}>
                                                                {/* <img
                                                                    className={styles.history_absolute_image}
                                                                    src={SOURCES_ICONS[idx]}
                                                                    alt={`Avatar ${idx + 1}`}
                                                                /> */}
                                                                <img
                                                                    className={styles.history_absolute_image}
                                                                    src={getFaviconUrl(source, idx)}
                                                                    alt='source'
                                                                />
                                                            </div>
                                                        ))}
                                                        {remainingCount > 0 && (
                                                            <div className={styles.history_image_group} style={{ background: '#FFE8AE', marginLeft: '2px', borderRadius: '50%', border: '1px solid #E8DCC1' }}>
                                                                <span style={{ fontSize: '13px', padding: '2px 4px' }}>{`+${remainingCount}`}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </>}
                                    </div>
                                );
                            })}
                        </InfiniteScroll>
                        {loading && <img src={LandingIcon} className={styles.landing_icon} alt='landing_icon' />}
                        {(!histories.length && !loading) && <span style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>No history found!</span>}
                    </div>
                </div>
                {width < 900 && <MobileNavigation />}
            </div>
        }
    </div>
    );
}

export default HistoryPage;